<template>
    <div>
        <div>
            <table class="table">
                <tr>
                    <td>Max value</td>
                    <td><!--{{risk_score.maxScore}}-->   {{maxScore}}</td>
                </tr>
                <!--<tr>
                    <td>Risk score</td>&lt;!&ndash; put slider &ndash;&gt;
                    <td>
                        <span>{{getScoreCard.riskScore}}</span>
                        <input v-model="local.scoreCard.riskScore" type="range"  min="0" max="1" step="0.01" class="form-control-range" id="formControlRange">
                    </td>
                </tr>-->
                <tr>
                    <td>Risk tolerance</td>
                    <td>
                        <div class="btn-group">
                            <button type="button" class="btn btn-danger" :class="riskRating == 'high' ? 'active' : ''" v-model="riskRating" @click="updateRiskRating('high')">High</button>
                            <button type="button" class="btn btn-warning" :class="riskRating == 'moderate' ? 'active' : ''" v-model="riskRating" @click="updateRiskRating('moderate')">Moderate</button>
                            <button type="button" class="btn btn-success" :class="riskRating == 'low' ? 'active' : ''" v-model="riskRating" @click="updateRiskRating('low')">Low</button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                </tr>
                <!--<tr>
                    <td>Risk tolerance score</td>
                    <td>{{getScoreCard.riskToleranceScore}}</td>
                </tr>
                <tr>
                    <td>Risk tolerance score (rounded)</td>
                    <td>{{getScoreCard.riskToleranceScoreRounded}}</td>
                </tr>-->

            </table>


            <!--<table class="table table-success table-decision">
                <thead>
                <tr>
                    <th scope="col">Decision</th>
                    <th scope="col">Suggested score</th>
                </tr>
                </thead>
                <tr v-for="(decision, decisionIndex) in local.decisions">
                    <td>{{decision.name}}</td>
                    <td>{{decision.label}}</td>
                </tr>
            </table>-->

            <create-decision-table-score :scenario-testing="false" :max-score="maxScore"></create-decision-table-score>

            <div class="btn-group">
                <button type="button" class="btn btn-success" @click="decisionComplete">Next</button>
            </div>
        </div>
    </div>
    
</template>

<script>
    import {mapMutations, mapState} from 'vuex';
    import DecisionTypesEnum from '../types/ConditionTypesEnum';
    import CreateDecisionTableScore from "./CreateDecisionTableScore";

    export default {
        name: "ScoreAssessment",
        components: {CreateDecisionTableScore},
        data() {
            return {
                local: {
                    considerations: [],
                    decisions: [],
                    scoreCard: {
                        riskScore: 0.67,
                    },
                },
                errors: [],
                conditionType: DecisionTypesEnum.BEST,
                //riskScore: 0.67,
                riskRating: 'low',
            };
        },

        methods: {

            ...mapMutations('data', [
                'commitConsiderations',
                'commitDecisionTable',
                'commitScoreCard'
            ]),

            decisionComplete() {
                const vm = this;
                // Store conditions
                //TODO: Move commit to addCondition to reduce potential data loss
                vm.commitDecisionTable(vm.local.decisions);
                //vm.commitScoreCard(vm.risk_score);
                vm.nextStep();
            },

            nextStep() {
                this.$router.push({name: 'scenariotesting'});
            },

            setRiskScore() {
                console.log('set risk score')
            },

            getTotalScore() {

                let maxScore = 0
                for(let i=0; i < this.local.considerations.length; i++) {
                    let conditions = this.local.considerations[i].conditions
                    let bestCondition = conditions.find(condition => condition.sequence == 0)
                    maxScore = maxScore + bestCondition.score
                }
                return maxScore
            },

            updateRiskRating(rating) {
                this.riskRating = rating

                let scoreCard = {
                    maxScore: this.getTotalScore(),
                    riskRating: rating
                }
                this.commitScoreCard(scoreCard);
            },

        },

        mounted() {

            //console.log(this.scoreRating)
            this.local.considerations = [...this.dataConsiderations];
            this.local.decisions = [...this.dataDecisions];
            this.local.scoreCard = {...this.dataScoreCard}

            /*if(typeof(this.$store.state.data.matrix.scoreCard.maxScore) == 'undefined') {
                this.commitScoreCard(this.risk_score); //set the default risk rating
            }
            this.local.scoreCard = {...this.dataScoreCard}*/


            if(typeof(this.$store.state.data.matrix.scoreCard.maxScore) == 'undefined') {

                let scoreCard = {
                    maxScore: this.getTotalScore(),
                    riskRating: this.riskRating
                }
                this.commitScoreCard(scoreCard); //set the default risk rating
            }
            //this.local.scoreCard = {...this.dataScoreCard}

            /*if(typeof(this.local.scoreCard.riskScore) != 'undefined') {
                this.local.scoreCard.riskScore = 0.67; //set to default value
            }*/


            if(this.local.scoreCard.riskRating) {
                this.riskRating = this.local.scoreCard.riskRating
            }else{
                this.riskRating = 'low'
            }

            let scoreCard = {
                maxScore: this.getTotalScore(),
                riskRating: this.riskRating
            }
            this.commitScoreCard(scoreCard); //set the default risk rating

        },

        computed: {
            ...mapState('data', {
                dataConsiderations: state => state.matrix.considerations,
                dataDecisions: state => state.matrix.decisions,
                dataScoreCard: state => state.matrix.scoreCard,
            }),

            ...mapState('config', [
                'scoreRating',
            ]),


            maxScore: function() {

                let maxScore = 0
                for(let i=0; i < this.local.considerations.length; i++) {
                    let conditions = this.local.considerations[i].conditions
                    let bestCondition = conditions.find(condition => condition.sequence == 0)
                    maxScore = maxScore + bestCondition.score
                }
                return maxScore
            },

            /*riskRating: {
                get() {
                    if(this.local.scoreCard.riskRating) {
                        return this.local.scoreCard.riskRating
                    }else{
                        return 'low'
                    }

                },

                set(rating) {
                    this.local.scoreCard.riskRating = rating

                    let scoreCard = {
                        maxScore: this.getTotalScore(),
                        riskRating: rating
                    }

                    this.commitScoreCard(scoreCard);
                }

            },*/

            /*risk_score: function () {

                //how many decisions?
                //what is the risk rating? create json object for risk rating?
                //decide tolerance values based on number of decisions using given table

                let decisionCount = this.local.decisions.length
                let scoreCard = {}

                if(!(_.isUndefined(this.scoreRating.decisions[decisionCount]))) {

                    let tolerance = this.scoreRating.decisions[decisionCount].tolerance
                    let riskRating = this.riskRating
                    let maxScore = this.maxScore

                    scoreCard = {
                        maxScore: maxScore,
                        riskRating: this.riskRating
                    }

                    let lower_score = Math.round(maxScore*tolerance[riskRating].lower)
                    let upper_score = Math.round(maxScore*tolerance[riskRating].upper)
                    let lower_intermediate = Math.round(maxScore*tolerance[riskRating].lower_intermediate)
                    let upper_intermediate = Math.round(maxScore*tolerance[riskRating].upper_intermediate)


                    switch (decisionCount) {
                        case 2:
                            this.local.decisions[0].lower_score = lower_score
                            this.local.decisions[0].label = 'More than ' + lower_score

                            this.local.decisions[1].upper_score = upper_score
                            this.local.decisions[1].label = 'Less than or equal ' + upper_score
                            break;

                        case 3:

                            this.local.decisions[0].lower_score = lower_score
                            this.local.decisions[0].label = 'More than ' + lower_score

                            this.local.decisions[1].lower_score = lower_score
                            this.local.decisions[1].upper_score = upper_score
                            this.local.decisions[1].label =  upper_score + ' to ' + lower_score

                            this.local.decisions[2].upper_score = upper_score
                            this.local.decisions[2].label =  'Less than or equal ' + upper_score
                            break;

                        case 4:

                            this.local.decisions[0].lower_score = lower_score
                            this.local.decisions[0].label = 'More than ' + lower_score

                            this.local.decisions[1].lower_score = lower_intermediate
                            this.local.decisions[1].upper_score = lower_score
                            this.local.decisions[1].label = lower_intermediate + ' to ' + lower_score

                            this.local.decisions[2].lower_score = upper_score
                            this.local.decisions[2].upper_score = upper_intermediate
                            this.local.decisions[2].label = upper_score + ' to ' + upper_intermediate

                            this.local.decisions[3].upper_score = upper_score
                            this.local.decisions[3].label = 'Less than ' + upper_score
                            break;
                    }
                }

                return scoreCard //we just return max score
            },*/

   /*         getScoreCard: function () {
                let maxScore = 0
                let riskToleranceScore = 0
                let riskToleranceScoreRounded = 0
                let lowerScore = 0
                let upperScore = 0
                let decision_count = this.local.decisions.length
                let scoreCard = {
                    maxScore: 0
                }

                for(let i=0; i < this.local.considerations.length; i++) {
                    let conditions = this.local.considerations[i].conditions
                    let bestCondition = conditions.find(condition => condition.sequence == 0)
                    maxScore = maxScore + bestCondition.score
                }

                riskToleranceScore = maxScore * this.local.scoreCard.riskScore
                riskToleranceScoreRounded = Math.round(maxScore * this.local.scoreCard.riskScore)

                switch (decision_count) {
                    case 2:
                        lowerScore = riskToleranceScoreRounded
                        upperScore = riskToleranceScoreRounded

                        this.local.decisions[0].lower_score = lowerScore
                        this.local.decisions[0].label = 'More than ' + lowerScore

                        this.local.decisions[1].upper_score = upperScore
                        this.local.decisions[1].label = 'Less than ' + upperScore

                        break;

                    case 3:
                        lowerScore = Math.round(riskToleranceScoreRounded + riskToleranceScoreRounded*10/100)
                        upperScore = Math.round(riskToleranceScoreRounded - riskToleranceScoreRounded*10/100)

                        this.local.decisions[0].lower_score = lowerScore
                        this.local.decisions[0].label = 'More than ' + lowerScore

                        this.local.decisions[1].lower_score = upperScore
                        this.local.decisions[1].upper_score = lowerScore
                        this.local.decisions[1].label =  upperScore + ' to ' + lowerScore

                        this.local.decisions[2].upper_score = upperScore
                        this.local.decisions[2].label =  'Less than ' + upperScore

                        break;
                    case 4:
                        lowerScore = Math.round(riskToleranceScoreRounded + riskToleranceScoreRounded*15/100)
                        upperScore = Math.round(riskToleranceScoreRounded - riskToleranceScoreRounded*15/100)

                        this.local.decisions[0].lower_score = lowerScore
                        this.local.decisions[0].label = 'More than ' + lowerScore

                        this.local.decisions[1].lower_score = riskToleranceScoreRounded
                        this.local.decisions[1].upper_score = lowerScore
                        this.local.decisions[1].label = riskToleranceScoreRounded + ' to ' + lowerScore

                        this.local.decisions[2].lower_score = upperScore
                        this.local.decisions[2].upper_score = riskToleranceScoreRounded - 1
                        this.local.decisions[2].label = upperScore + ' to ' + (riskToleranceScoreRounded - 1)

                        this.local.decisions[3].upper_score = upperScore
                        this.local.decisions[3].label = 'Less than ' + upperScore

                        break;
                }

                scoreCard.maxScore = maxScore
                scoreCard.riskScore = this.local.scoreCard.riskScore
                scoreCard.riskToleranceScore = riskToleranceScore
                scoreCard.riskToleranceScoreRounded = riskToleranceScoreRounded
                scoreCard.lowerScore = lowerScore
                scoreCard.upperScore = upperScore

                return scoreCard
            },*/

            getRiskToleranceScore: function () {
                //return this.getMaxScore()
            }
        },

    }
</script>

<style scoped>
    .table-decision {
        background-color: #f3fff8;
    }

    .btn.active {
        border-width: 2px;
        border-color: #456853 !important;
    }
</style>